AddMake = App.loadClass "grower::handlers/machinery/DialogAddMake_Handler"
AddModel = App.loadClass "grower::handlers/machinery/DialogAddMod_Handler"

exports.Tillage = (parent, data = {}) ->
    self = this

    @addMake = () ->
        dlg = parent.getHandler().createSubHandler AddMake, 'addMachDialog'
        if dlg
            dlg.subtypeId = self.selected_subtype().id
            dlg.saveUrl = 'backend/grower/machinery/add-machinery-make'
            dlg.isforcontroll = false
            dlg.successAction = (data) ->
                data.data.models = []
                newm = data.data
                self.machinery_makes.push newm
                self.machinery_makes.sort self._comp
                self.selected_make newm
                self.addModel()
                parent.getHandler().validator.revalidateInput("[name='selected_make']")

            dlg.init()


    @addModel = () ->
        dlg = parent.getHandler().createSubHandler AddModel, 'addMachDialog'
        if dlg
            dlg.saveUrl = 'backend/grower/machinery/add-machinery-model'
            dlg.isforcontroll = false
            dlg.makeId = self.selected_make().id
            dlg.successAction = (data) ->
                newm = data.data
                self.selected_make().models.push newm
                self.machinery_models.sort self._comp
                self.selected_model newm
                parent.getHandler().validator.revalidateInput("[name='selected_model']")

            dlg.init()


    @comp = (a, b) ->
        return strnatcasecmp(a.name, b.name)


    # Machinery subytpes / makes / models
    if data.machinery?.model?
        subtype = TAFFY(data.subtypes)(id: parseInt(data.machinery?.model.make.subtype.id)).first()
        make = TAFFY(subtype.makes)(id: parseInt(data.machinery?.model.make.id)).first() if subtype?
        model = TAFFY(make.models)(id: parseInt(data.machinery?.model.id)).first() if make?

    @selected_subtype   = ko.observable subtype ? null
    @selected_make      = ko.observable make ? null
    @selected_model     = ko.observable model ? null

    @machinery_subtypes = data.subtypes ? []
    @machinery_makes    = ko.observableArray @selected_subtype()?.makes ? []
    @machinery_models   = ko.observableArray @selected_make()?.models ? []

    @selected_subtype.subscribe (newval) ->
        if newval? and newval.makes?
            self.machinery_makes newval.makes
        else
            self.machinery_makes []

    @selected_make.subscribe (newval) ->
        if newval? and newval.models?
            self.machinery_models newval.models
        else
            self.machinery_models []

    @id          = data.machinery?.id ? null
    @nickname    = ko.observable data.machinery?.name ? null
    @type        = ko.observable data.machinery?.model.make.subtype.name ? null
    @width       = ko.observable data.machinery?.width ? null

    @canChangeMake = ko.computed () ->
        if self.selected_subtype() and parent.editing()
            return true
        else
            return false

    @canChangeModel = ko.computed () ->
        if self.selected_make() and parent.editing()
            return true
        else
            return false

    return this

